import React, { useEffect, useState } from "react";
import { Row, Col, Table, Spinner, Form } from "react-bootstrap";
import { Link } from 'react-router-dom';
import './LicitacoesContratos.css';
import debounce from 'lodash.debounce';
//import CleanPagination from '../Components/CleanPagination';

export default function Licitações() {
    let [licitacoes, setLicitacoes] = useState([]);
    let [loading, setLoading] = useState(true);
    let [page, setPage] = useState(0);

    let [ordenacao, setOrdenacao] = useState({
        campo: "NUMEROPROCESSO",
        ordem: "DESC"
    });

    let [formData, setFormData] = useState({
        ano: "",
        texto: "",
        modalidade: "",
        ordenacao: "NUMEROPROCESSODESC"
    });
    let years = [];
    let currentYear = new Date().getFullYear();
    
    while (currentYear > 2012) {
        years.push(currentYear);
        currentYear--;
    } 

    const modalidades = ["Concorrência",
        "Convite",
        "Dispensa",
        "Inexigibilidade",
        "Leilão",
        "Pregão Eletrônico",
        "Pregão Presencial",
        "Tomada de Preços"];

    const previousPage = () => {
        setPage(page - 1);
    };

    const nextPage = () => {
        setPage(page + 1);
    };

    const getData = () => {
        setLoading(true);
        fetch('https://www.alepe.pe.gov.br/ajax/?evento=dispensas-licitacao')
            .then(result => result.json())
            .then((jsonResult) => {
                jsonResult = jsonResult.filter(item => item.tipo !== 'chamamento');
                setLicitacoes(jsonResult); // Atualiza o estado com os dados recebidos
                setLoading(false);
            })
            .catch((error) => {
                console.error("Erro ao buscar dados: ", error);
                setLoading(false);
            });
    }

    useEffect(() => {
         getData();
    }, [formData, page]);

    useEffect(() => {
        setFormData({...formData, ordenacao: (ordenacao.campo + ordenacao.ordem)})
    }, [ordenacao]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const debouncedHandleInputChange = debounce(handleInputChange, 500);

    const handleInputChangeOrdenacao = (e) => {
        const { name, value } = e.target;
        setOrdenacao({ ...ordenacao, [name]: value });
    };

    return <Row>
        <Col xs="12">
            <p><small>Você está em <a href="/financas">Prestação de Contas</a> / Dispensas de Licitação</small></p>
        </Col>
        <Col xs="12">
            <h2 style={{fontSize: "170%"}}>Dispensas de licitação (Art. no 75, inciso II da lei 14.133/2021)</h2>
        </Col>
        <br/>
        <br/>
        <Col xs="12" className="text-center">
            {loading ? <Spinner/> : null}
        </Col>
        <Col xs="12">
            <div className="table-responsive">

    {licitacoes.map((licitacao, index) => (
        <React.Fragment key={index}>
            <Table striped bordered hover style={{marginTop: '20px'}}>
    <tbody>
            <tr style={{marginTop: '10px'}}>
                <th>Aviso de Dispensa</th>
                <th colSpan={2}>
                    {licitacao.postAviso.split('\r\n').map((line, index) => (
                        <React.Fragment key={index}>
                            {line}
                            <br />
                        </React.Fragment>
                    ))}
                </th>
            </tr>
            <tr>
                <th><b>Nº da Dispensa</b></th>
                <th><b>Arquivos</b></th>
                <th><b>Objeto</b></th>
            </tr>
            <tr>
                <td style={{ width: '13%' }}>{licitacao.postNumero}</td>

                <td style={{ width: '23%' }}>
                    {licitacao.arquivos && licitacao.arquivos.map((arquivo, index) => (
                        <React.Fragment key={index}>
                            <a href={arquivo.url} target="_blank">
                                {arquivo.titulo}
                            </a>
                            <br /> <br />
                        </React.Fragment>
                    ))}
                </td>

                <td>{licitacao.postObjeto}</td>
            </tr>
        {/* <tr>
            <th>Aviso de Dispensa</th>
            <th colSpan={2}>
                AVISO DE DISPENSA Nº 012/2024 – COM BASE NO ART. Nº 75, INCISO II, da Lei 14.133/2021
                <br/><br/>
                A ASSEMBLEIA LEGISLATIVA DE PERNAMBUCO, em conformidade com Art. 75, inciso II, da Lei Federal n.º 14.133/2021, torna público aos interessados que pretende realizar a CONTRATAÇÃO DE EMPRESA DE ENGENHARIA ESPECIALIZADA EM ELABORAÇÃO DE PROJETOS PARA ELABORAR PROJETO BÁSICO DE INSTALAÇÕES ELÉTRICAS PARA AMPLIAÇÃO DO SISTEMA ELÉTRICO DOS EDIFÍCIOS MIGUEL ARRAES E ANEXO 2 DA ALEPE PARA NOVO SISTEMA DE CLIMATIZAÇÃO, podendo eventuais interessados apresentarem Proposta de Preços no prazo de 3 (três) dias úteis, a contar desta Publicação, oportunidade em que a administração escolherá a mais vantajosa.
                <br/><br/>
                Limite para Apresentação da Proposta de Preços: 12/08/2024 às 14:00h
                <br/><br/>
                A documentação de habilitação e proposta de Preços deverá ser encaminhada para o E-mail: licitacao@alepe.pe.gov.br, até a data limite. O Edital/Termo de Referência da Dispensa estará disponível no Site Oficial da ALEPE https://transparencia.alepe.pe.gov.br/ ou através do E-mail: licitacao@alepe.pe.gov.br. Outras informações poderão ser obtidas na Sala da CPL, sito a Rua da União, nº 439, 3º andar, Boa Vista, Recife/PE, no horário das 08h:00 às 18h:00 de segunda a quinta e nas sextas feiras até as 13h:00. Recife, 06 de agosto de 2024.
            </th>
        </tr>
        <tr>
            <th><b>Nº da Dispensa</b></th>
            <th><b>Arquivos</b></th>
            <th><b>Objeto</b></th>
        </tr>
        <tr>
            <td style={{ width: '13%'}}>012/2024</td>
            <td style={{ width: '23%'}}>
                <a href="https://www.alepe.pe.gov.br/downloads/dispensa/edital-dispensa-12-2024.pdf" target="_blank">Edital</a><br/><br/>
                <a href="https://www.alepe.pe.gov.br/downloads/dispensa/Composicao_de_preco.pdf" target="_blank">Composicao_de_preco</a><br/><br/>
                <a href="https://www.alepe.pe.gov.br/downloads/dispensa/Cronograma_fisico-financeiro.pdf" target="_blank">Cronograma_fisico-financeiro</a><br/><br/>
                <a href="https://www.alepe.pe.gov.br/downloads/dispensa/DFD_Projeto_Engenharia_Eletrica.pdf" target="_blank">DFD_Projeto_Engenharia_Eletrica</a><br/><br/>
                <a href="https://www.alepe.pe.gov.br/downloads/dispensa/ESTUDO_TECNICO_PRELIMINAR.pdf" target="_blank">ESTUDO_TECNICO_PRELIMINAR</a><br/><br/>
                <a href="https://www.alepe.pe.gov.br/downloads/dispensa/TR-07-24_-_CONTRATACAO_DE_PROJETO_ELETRICO_-_MIGUEL_ARRAES_E_ANEXO_2_-_POR_DISPENSA_Assinado.pdf" target="_blank">TR-07-24_-_CONTRATACAO_DE_PROJETO_ELETRICO_-_MIGUEL_ARRAES_E_ANEXO_2_-_POR_DISPENSA_Assinado</a>
            </td>
            <td>CONTRATAÇÃO DE EMPRESA DE ENGENHARIA ESPECIALIZADA EM ELABORAÇÃO DE PROJETOS PARA ELABORAR PROJETO BÁSICO DE INSTALAÇÕES ELÉTRICAS PARA AMPLIAÇÃO DO SISTEMA ELÉTRICO DOS EDIFÍCIOS MIGUEL ARRAES E ANEXO 2 DA ALEPE PARA NOVO SISTEMA DE CLIMATIZAÇÃO.</td>
        </tr> */}
    </tbody>
    
</Table>
</React.Fragment>))}

            {/* <Table striped bordered hover>
    <tbody>
        <tr>
            <th>Aviso de Dispensa</th>
            <th colSpan={2}>
                AVISO DE DISPENSA Nº 011/2024 - REPETIÇÃO – COM BASE NO ART. Nº 75, INCISO II, da Lei 14.133/2021
                <br/><br/>
                A ASSEMBLEIA LEGISLATIVA DE PERNAMBUCO, em conformidade com Art. 75, inciso II, da Lei Federal n.º 14.133/2021, torna público aos interessados que pretende realizar a CONTRATAÇÃO DE EMPRESA PARA FORNECIMENTO DE CERTIFICADOS DIGITAIS ICP-BRASIL, PARA ATENDER AS DEMANDAS DA ASSEMBLEIA LEGISLATIVA DO ESTADO DE PERNAMBUCO, podendo eventuais interessados apresentarem Proposta de Preços no prazo de 3 (três) dias úteis, a contar desta Publicação, oportunidade em que a administração escolherá a mais vantajosa.
                <br/><br/>
                Limite para Apresentação da Proposta de Preços: 12/08/2024 às 14:00h
                <br/><br/>
                A documentação de habilitação e proposta de Preços deverá ser encaminhada para o E-mail: licitacao@alepe.pe.gov.br, até a data limite. O Edital/Termo de Referência da Dispensa estará disponível no Site Oficial da ALEPE https://transparencia.alepe.pe.gov.br/ ou através do E-mail: licitacao@alepe.pe.gov.br. Outras informações poderão ser obtidas na Sala da CPL, sito a Rua da União, nº 439, 3º andar, Boa Vista, Recife/PE, no horário das 08h:00 às 18h:00 de segunda a quinta e nas sextas feiras até as 13h:00. Recife, 06 de agosto de 2024.
            </th>
        </tr>
        <tr>
            <th><b>Nº da Dispensa</b></th>
            <th><b>Arquivos</b></th>
            <th><b>Objeto</b></th>
        </tr>
        <tr>
            <td style={{ width: '13%'}}>011/2024</td>
            <td style={{ width: '23%'}}>
                <a href="https://www.alepe.pe.gov.br/downloads/dispensa/edital-dispensa-11-2-2024.pdf" target="_blank">Edital</a>
            </td>
            <td>CONTRATAÇÃO DE EMPRESA PARA FORNECIMENTO DE CERTIFICADOS DIGITAIS ICP-BRASIL, PARA ATENDER AS DEMANDAS DA ASSEMBLEIA LEGISLATIVA DO ESTADO DE PERNAMBUCO.</td>
        </tr>
    </tbody>
</Table>

            <Table striped bordered hover>
                    <tbody>
                        <tr>
                            <th>Aviso de Dispensa</th>
                            <th colSpan={2}>
                                AVISO DE DISPENSA Nº 011/2024 – COM BASE NO ART. Nº 75, INCISO II, da Lei 14.133/2021
                                <br/><br/>
                                A ASSEMBLEIA LEGISLATIVA DE PERNAMBUCO, em conformidade com Art. 75, inciso II, da Lei Federal n.º 14.133/2021, torna público aos interessados que  pretende realizar a CONTRATAÇÃO DE EMPRESA PARA FORNECIMENTO DE CERTIFICADOS DIGITAIS ICP-BRASIL, PARA ATENDER AS DEMANDAS DA ASSEMBLEIA LEGISLATIVA DO ESTADO DE PERNAMBUCO, podendo eventuais interessados apresentarem Proposta de Preços no prazo de 3 (três) dias úteis, a contar desta Publicação, oportunidade em que a administração escolherá a mais vantajosa.
                                <br/><br/>
                                Limite para Apresentação da Proposta de Preços: DIA 26/07/2024, ÀS 14:00 HORAS.
                                <br/><br/>
                                A documentação de habilitação e proposta de Preços deverá ser encaminhada para o E-mail: licitacao@alepe.pe.gov.br,  até a data limite. O Edital/Termo de Referência da Dispensa estará disponível no Site Oficial da ALEPE https://transparencia.alepe.pe.gov.br/ ou através do E-mail: licitacao@alepe.pe.gov.br. Outras informações poderão ser obtidas na sala da CPL, sito a Rua da União, nº 439, 3º andar, Boa Vista, Recife/PE, no horário das 08h:00 às 18h:00 de segunda a quinta e nas sextas feiras até as 13h:00. Recife, 22 de julho de 2024.
                            </th>
                        </tr>
                        <tr>
                            <th><b>Nº da Dispensa</b></th>
                            <th><b>Arquivos</b></th>
                            <th><b>Objeto</b></th>
                        </tr>
                        <tr>
                            <td style={{ width: '13%'}}>011/2024</td>
                            <td style={{ width: '23%'}}>
                                <a href="https://www.alepe.pe.gov.br/downloads/dispensa/edital-dispensa-11-2024.pdf" target="_blank">Edital</a>
                            </td>
                            <td>CONTRATAÇÃO DE EMPRESA PARA FORNECIMENTO DE CERTIFICADOS DIGITAIS ICP-BRASIL, PARA ATENDER AS DEMANDAS DA ASSEMBLEIA LEGISLATIVA DO ESTADO DE PERNAMBUCO</td>
                        </tr>
                    </tbody>
                </Table>

                <Table striped bordered hover>
                    <tbody>
                        <tr>
                            <th>Aviso de Dispensa</th>
                            <th colSpan={2}>
                                AVISO DE DISPENSA nº 008/2024 – COM BASE NO ART. Nº 75, INCISO II da Lei 14.133/2021
                                <br/><br/>
                                A ASSEMBLEIA LEGISLATIVA DE PERNAMBUCO, em conformidade com Art. 75, inciso II – da Lei Federal n.º 14.133/2021, torna público aos interessados que pretende realizar a CONTRATAÇÃO DE EMPRESA PARA FORNECIMENTO DE CORDÃO SIMPLES PARA CRACHÁ EM 100% POLIÉSTER AZUL PERSONALIZADO, PARA ATENDER AS NECESSIDADES DESTA CASA, podendo eventuais interessados apresentarem Proposta de Preços no prazo de 3 (três) dias úteis, a contar desta Publicação, oportunidade em que a administração escolherá a mais vantajosa.
                                <br/><br/>
                                Limite para Apresentação da Proposta de Preços: 11/06/2024 às 14:00h
                                <br/><br/>
                                A documentação de habilitação e proposta de Preços deverá ser encaminhada para o E-mail: licitacao@alepe.pe.gov.br, até a data limite. O Edital/Termo de Referência da Dispensa estará disponível no Site Oficial da ALEPE https://transparencia.alepe.pe.gov.br/ ou através do E-mail: licitacao@alepe.pe.gov.br. Outras informações poderão ser obtidas na Sala da CPL, sito a Rua da União, nº 439, 3º andar, Boa Vista, Recife/PE, no horário das 08h:00 às 18h:00 de segunda a quinta e nas sextas feiras até as 13h:00. Recife, 05 de junho de 2024.
                            </th>
                        </tr>
                        <tr>
                            <th><b>Nº da Dispensa</b></th>
                            <th><b>Arquivos</b></th>
                            <th><b>Objeto</b></th>
                        </tr>
                        <tr>
                            <td style={{ width: '13%'}}>008/2024</td>
                            <td style={{ width: '23%'}}>
                                <a href="https://www.alepe.pe.gov.br/downloads/dispensa/edital-dispensa-08-2024.pdf" target="_blank">Edital</a>
                            </td>
                            <td>CONTRATAÇÃO DE EMPRESA PARA FORNECIMENTO DE CORDÃO SIMPLES PARA CRACHÁ EM 100% POLIÉSTER AZUL PERSONALIZADO, PARA ATENDER AS NECESSIDADES DESTA CASA.</td>
                        </tr>
                    </tbody>
                </Table>
                <Table striped bordered hover>
                    <tbody>
                        <tr>
                            <th>Aviso de Dispensa</th>
                            <th colSpan={2}>
                                AVISO DE DISPENSA nº 007/2024 – COM BASE NO ART. Nº 75, INCISO II, da Lei 14.133/2021
                                <br/><br/>
                                A ASSEMBLEIA LEGISLATIVA DE PERNAMBUCO, em conformidade com Art. 75, inciso II – da Lei Federal n.º 14.133/2021, torna público aos interessados que a administração municipal pretende realizar a Contratação de empresa especializada no ramo de lavagem, higienização e sanitização em carpetes, tapetes, sofá e cadeiras dos Plenarinhos 1, 2, e 3, do Auditório Sergio Guerra,  Auditório Ênio Guerra no Edifício Miguel Arraes e do Estar dos Deputados no Edifício João Negromonte da ALEPE, podendo eventuais interessados apresentarem Proposta de Preços no prazo de 3 (três) dias úteis, a contar desta Publicação, oportunidade em que a administração escolherá a mais vantajosa.
                                <br/><br/>
                                Limite para Apresentação da Proposta de Preços: 15/05/2024 às 14:00h
                                <br/><br/>
                                A documentação de habilitação e proposta de Preços deverá ser encaminhada para o E-mail: alepe.licita@gmail.com, até a data limite. O Edital/Termo de Referência da Dispensa estará disponível no Site Oficial da ALEPE https://transparencia.alepe.pe.gov.br/ ou através do E-mail: licitacao@alepe.pe.gov.br. Outras informações poderão ser obtidas na Sala da CPL, sito a Rua da União, nº 439, 3º andar, Boa Vista, Recife/PE, no horário das 08h:00 às 18h:00 de segunda a quinta e nas sextas feiras até as 13h:00. Recife, 09 de maio de 2024.
                            </th>
                        </tr>
                        <tr>
                            <th><b>Nº da Dispensa</b></th>
                            <th><b>Arquivos</b></th>
                            <th><b>Objeto</b></th>
                        </tr>
                        <tr>
                            <td style={{ width: '13%'}}>007/2024</td>
                            <td style={{ width: '23%'}}>
                                <Link to={"https://www.alepe.pe.gov.br/downloads/dispensa/edital-dispensa-07-2024.pdf"} target="_blank">Edital</Link>
                            </td>
                            <td>CONTRATAÇÃO DE EMPRESA ESPECIALIZADA NO RAMO DE LAVAGEM, HIGIENIZAÇÃO E SANITIZAÇÃO EM CARPETES, TAPETES, SOFÁ E CADEIRAS DOS PLENARINHOS 1, 2, E 3, DO AUDITÓRIO SERGIO GUERRA, AUDITÓRIO ÊNIO GUERRA NO EDIFÍCIO MIGUEL ARRAES E DO ESTAR DOS DEPUTADOS NO EDIFÍCIO JOÃO NEGRONTE DA ALEPE.</td>
                        </tr>
                    </tbody>
                </Table>
                <Table striped bordered hover>
                    <tbody>
                        <tr>
                            <th>Aviso de Dispensa</th>
                            <th colSpan={2}>
                                AVISO DE DISPENSA nº 006/2024 – COM BASE NO ART. Nº 75, INCISO I da Lei 14.133/2021
                                <br/><br/>
                                A ASSEMBLEIA LEGISLATIVA DE PERNAMBUCO, em conformidade com Art. 75, inciso I – da Lei Federal n.º 14.133/2021, torna público aos interessados que a administração municipal pretende realizar a CONTRATAÇÃO DE EMPRESA DE ENGENHARIA PARA REFORMA E RECUPERAÇÃO DA CÚPULA SOBRE O PLENÁRIO DOS DEPUTADOS, NO EDIFÍCIO MIGUEL ARRAES, podendo eventuais interessados apresentarem Proposta de Preços no prazo de 3 (três) dias úteis, a contar desta Publicação, oportunidade em que a administração escolherá a mais vantajosa.
                                <br/><br/>
                                Limite para Apresentação da Proposta de Preços: 10/05/2024 às 14:00h
                                <br/><br/>
                                A documentação de habilitação e proposta de Preços deverá ser encaminhada para o E-mail: alepe.licita@gmail.com, até a data limite. O Edital/Termo de Referência da Dispensa estará disponível no Site Oficial da ALEPE https://transparencia.alepe.pe.gov.br/ ou através do E-mail: alepe.licita@gmail.com. Outras informações poderão ser obtidas na Sala da CPL, sito a Rua da União, nº 439, 3º andar, Boa Vista, Recife/PE, no horário das 08h:00 às 18h:00 de segunda a quinta e nas sextas feiras até as 13h:00. Recife, 07 de abril de 2024.
                            </th>
                        </tr>
                        <tr>
                            <th><b>Nº da Dispensa</b></th>
                            <th><b>Arquivos</b></th>
                            <th><b>Objeto</b></th>
                        </tr>
                        <tr>
                            <td style={{ width: '13%'}}>006/2024</td>
                            <td style={{ width: '23%'}}>
                                <Link to={"https://www.alepe.pe.gov.br/downloads/dispensa/edital-dispensa-06-2024.pdf"} target="_blank">Edital</Link>
                            </td>
                            <td>CONTRATAÇÃO DE EMPRESA DE ENGENHARIA PARA REFORMA E RECUPERAÇÃO DA CÚPULA SOBRE O PLENÁRIO DOS DEPUTADOS, NO EDIFÍCIO MIGUEL ARRAES.</td>
                        </tr>
                    </tbody>
                </Table>

                <Table striped bordered hover>
                    <tbody>
                        <tr>
                            <th>Aviso de Dispensa</th>
                            <th colSpan={2}>
                                AVISO DE DISPENSA nº 005/2024 – COM BASE NO ART. Nº 75, INCISO II, da Lei 14.133/2021
                                <br/><br/>
                                A ASSEMBLEIA LEGISLATIVA DE PERNAMBUCO, em conformidade com Art. 75, inciso I – da Lei Federal n.º 14.133/2021, torna público aos interessados que pretende realizar a Contratação de empresa especializada para a prestação de serviços de manutenção corretiva nas gavetas de potência marca Hitachi Kokusai Linear, modelo MOD GV 4751A, números de série TY-269, TY-273, TY-274 e TY-S/N, do sistema de transmissão digital da TV da Rede Legislativa (TV Câmara, TV Alepe e TV Senado, podendo eventuais interessados apresentarem Proposta de Preços no prazo de 3 (três) dias úteis, a contar desta Publicação, oportunidade em que a administração escolherá a mais vantajosa. 
                                <br/><br/>
                                Limite para Apresentação da Proposta de Preços: 06/05/2024 às 14:00h
                                <br/><br/>
                                A documentação de habilitação e proposta de Preços deverá ser encaminhada para o E-mail: licitacao@alepe.pe.gov.br,   até a data limite. O Edital/Termo de Referência da Dispensa estará disponível no Site Oficial da ALEPE https://transparencia.alepe.pe.gov.br/ ou através do E-mail: licitacao@alepe.pe.gov.br.  Outras informações poderão ser obtidas na Sala da CPL, sito a Rua da União, nº 439, 3º andar, Boa Vista, Recife/PE, no horário das 08h:00 às 18h:00 de segunda a quinta e na sextas feiras até as 13h:00. Recife, 30 de abril de 2024.
                            </th>
                        </tr>
                        <tr>
                            <th><b>Nº da Dispensa</b></th>
                            <th><b>Arquivos</b></th>
                            <th><b>Objeto</b></th>
                        </tr>
                        <tr>
                            <td style={{ width: '13%'}}>005/2024</td>
                            <td style={{ width: '23%'}}>
                                <Link to={"https://www.alepe.pe.gov.br/downloads/dispensa/edital-dispensa-05-2024.pdf"} target="_blank">Edital</Link>
                            </td>
                            <td>CONTRATAÇÃO DE EMPRESA ESPECIALIZADA PARA A PRESTAÇÃO DE SERVIÇOS DE MANUTENÇÃO CORRETIVA NAS GAVETAS DE POTÊNCIA MARCA HITACHI KOKUSAI LINEAR, MODELO MOD GV 4751A, NÚMEROS DE SÉRIE TY-269, TY-273, TY-274 E TY-S/N, DO SISTEMA DE TRANSMISSÃO DIGITAL DA TV DA REDE LEGISLATIVA (TV CÂMARA, TV ALEPE E TV SENADO.</td>
                        </tr>
                    </tbody>
                </Table>
                <Table striped bordered hover>
                    <tbody>
                        <tr>
                            <th>Aviso de Dispensa</th>
                            <th colSpan={2}>
                                AVISO DE DISPENSA nº 004/2024 – COM BASE NO ART. Nº 75, INCISO I da Lei 14.133/2021
                                <br/><br/>
                                A ASSEMBLEIA LEGISLATIVA DE PERNAMBUCO, em conformidade com Art. 75, inciso I – da Lei Federal n.º 14.133/2021, torna público aos interessados que a administração municipal pretende realizar a CONTRATAÇÃO DE EMPRESA DE ENGENHARIA PARA PRESTAÇÃO DE SERVIÇOS DE ELABORAÇÃO DE PROJETOS PARA PRODUÇÃO DE ENERGIA ELÉTRICA DE FONTE RENOVÁVEL, POR MEIO DE PAINÉIS FOTOVOLTAICOS, A FIM DE ATENDER À DEMANDA ENERGÉTICA DA ALEPE (ASSEMBLÉIA LEGISLATIVA DO ESTADO DE PERNAMBUCO), podendo eventuais interessados apresentarem Proposta de Preços no prazo de 3 (três) dias úteis, a contar desta Publicação, oportunidade em que a administração escolherá a mais vantajosa.
                                <br/><br/>
                                Limite para Apresentação da Proposta de Preços: 05/04/2024 às 14:00h
                                <br/><br/>
                                A documentação de habilitação e proposta de Preços deverá ser encaminhada para o E-mail: alepe.licita@gmail.com, até a data limite. O Edital/Termo de Referência da Dispensa estará disponível no Site Oficial da ALEPE https://transparencia.alepe.pe.gov.br/ ou através do E-mail: alepe.licita@gmail.com. Outras informações poderão ser obtidas na Sala da CPL, sito a Rua da União, nº 439, 3º andar, Boa Vista, Recife/PE, no horário das 08h:00 às 18h:00 de segunda a quinta e nas sextas feiras até as 13h:00. Recife, 01 de abril de 2024.
                            </th>
                        </tr>
                        <tr>
                            <th><b>Nº da Dispensa</b></th>
                            <th><b>Arquivos</b></th>
                            <th><b>Objeto</b></th>
                        </tr>
                        <tr>
                            <td style={{ width: '13%'}}>004/2024</td>
                            <td style={{ width: '23%'}}>
                                <Link to={"https://www.alepe.pe.gov.br/downloads/dispensa/edital-dispensa-04-2024.pdf"} target="_blank">Edital</Link>
                            </td>
                            <td>CONTRATAÇÃO DE EMPRESA DE ENGENHARIA PARA PRESTAÇÃO DE SERVIÇOS DE ELABORAÇÃO DE PROJETOS PARA PRODUÇÃO DE ENERGIA ELÉTRICA DE FONTE RENOVÁVEL, POR MEIO DE PAINÉIS FOTOVOLTAICOS.</td>
                        </tr>
                    </tbody>
                </Table>
                <Table striped bordered hover>
                    <tbody>
                        <tr>
                            <th>Aviso de Dispensa</th>
                            <th colSpan={2}>
                                AVISO DE DISPENSA nº 003/2024 – COM BASE NO ART. Nº 75, INCISO I da Lei 14.133/2021
                                <br/><br/>
                                A ASSEMBLEIA LEGISLATIVA DE PERNAMBUCO, em conformidade com Art. 75, inciso I – da Lei Federal n.º 14.133/2021, torna público aos interessados que a administração municipal pretende realizar a CONTRATAÇÃO DE EMPRESA DE ENGENHARIA PARA REFORMA E RECUPERAÇÃO DA CÚPULA SOBRE O PLENÁRIO DOS DEPUTADOS, NO EDIFÍCIO MIGUEL ARRAES, podendo eventuais interessados apresentarem Proposta de Preços no prazo de 3 (três) dias úteis, a contar desta Publicação, oportunidade em que a administração escolherá a mais vantajosa.
                                <br/><br/>
                                Limite para Apresentação da Proposta de Preços: 05/04/2024 às 14:00h
                                <br/><br/>
                                A documentação de habilitação e proposta de Preços deverá ser encaminhada para o E-mail: alepe.licita@gmail.com, até a data limite. O Edital/Termo de Referência da Dispensa estará disponível no Site Oficial da ALEPE https://transparencia.alepe.pe.gov.br/ ou através do E-mail: alepe.licita@gmail.com. Outras informações poderão ser obtidas na Sala da CPL, sito a Rua da União, nº 439, 3º andar, Boa Vista, Recife/PE, no horário das 08h:00 às 18h:00 de segunda a quinta e nas sextas feiras até as 13h:00. Recife, 01 de abril de 2024.
                            </th>
                        </tr>
                        <tr>
                            <th><b>Nº da Dispensa</b></th>
                            <th><b>Arquivos</b></th>
                            <th><b>Objeto</b></th>
                        </tr>
                        <tr>
                            <td style={{ width: '13%'}}>003/2024</td>
                            <td style={{ width: '23%'}}>
                                <Link to={"https://www.alepe.pe.gov.br/downloads/dispensa/edital-dispensa-03-2024.pdf"} target="_blank">Edital</Link>
                            </td>
                            <td>CONTRATAÇÃO DE EMPRESA DE ENGENHARIA PARA REFORMA E RECUPERAÇÃO DA CÚPULA SOBRE O PLENÁRIO DOS DEPUTADOS, NO EDIFÍCIO MIGUEL ARRAES.</td>
                        </tr>
                    </tbody>
                </Table>
                <Table striped bordered hover>
                    <tbody>
                        <tr>
                            <th>Aviso de Dispensa</th>
                            <th colSpan={2}>
                            AVISO DE DISPENSA nº 002/2024 – COM BASE NO ART. Nº 75, INCISO II da Lei 14.133/2021
                            <br/>
                            <br/>
                            A ASSEMBLEIA LEGISLATIVA DE PERNAMBUCO, em conformidade com Art. 75, inciso II – da Lei Federal n.º 14.133/2021, torna público aos interessados que a administração municipal pretende realizar a CONTRATAÇÃO DE PESSOA JURÍDICA QUE POSSUA AS CONDIÇÕES NECESSÁRIAS PARA PRESTAÇÃO DE SERVIÇO ESPECIALIZADO EM DIAGNÓSTICO POR IMAGEM - MAMOGRAFIA BILATERAL DIGITAL E ULTRASSONOGRAFIA, EM UNIDADE MÓVEL ITINERANTE COM FORNECIMENTO DE MÉDICO ESPECIALIZADO EM DIAGNÓSTICO POR IMAGEM PARA EMISSÃO DE LAUDOS, E FORNECIMENTO DE PROFISSIONAL CAPACITADO PARA REALIZAÇÃO DO EXAME CLÍNICO DAS MAMAS, COM MÃO DE OBRA QUALIFICADA E INSUMOS NECESSÁRIOS PARA ATENDIMENTO AOS SERVIDORES DESTA CASA LEGISLATIVA E A POPULAÇÃO EM GERAL ATRAVÉS DO PROGRAMA ALEPE MULHER, podendo eventuais interessados apresentarem Proposta de Preços no prazo de 3 (três) dias úteis, a contar desta Publicação, oportunidade em que a administração escolherá a mais vantajosa.
                            <br/>
                            <br/>
                            Limite para Apresentação da Proposta de Preços: 28/02/2024 às 14:00h
                            <br/>
                            <br/>
                            A documentação de habilitação e proposta de Preços deverá ser encaminhada para o E-mail: alepe.licita@gmail.com,   até a data limite. O Edital/Termo de Referência da Dispensa estará disponível no Site Oficial da ALEPE https://transparencia.alepe.pe.gov.br/ ou através do E-mail: alepe.licita@gmail.com.  Outras informações poderão ser obtidas na Sala da CPL, sito a Rua da União, nº 439, 3º andar, Boa Vista, Recife/PE, no horário das 08h:00 às 18h:00 de segunda a quinta e nas sextas feiras até as 13h:00. Recife, 23 de fevereiro de 2024.
                            </th>
                        </tr>
                        <tr>
                            <th><b>Nº da Dispensa</b></th>
                            <th><b>Arquivos</b></th>
                            <th><b>Objeto</b></th>
                        </tr>
                        <tr>
                            <td style={{ width: '13%'}}>{2 + "/" + 2024}</td>
                            <td style={{ width: '23%'}}>
                                <Link to={"https://www.alepe.pe.gov.br/downloads/dispensa/edital-dispensa-02-2024.pdf"} target="_blank">Edital</Link>
                            </td>
                            <td>CONTRATAÇÃO DE PESSOA JURÍDICA QUE POSSUA AS CONDIÇÕES NECESSÁRIAS PARA PRESTAÇÃO DE SERVIÇO ESPECIALIZADO EM DIAGNÓSTICO POR IMAGEM - MAMOGRAFIA BILATERAL DIGITAL E ULTRASSONOGRAFIA, EM UNIDADE MÓVEL ITINERANTE COM FORNECIMENTO DE MÉDICO ESPECIALIZADO EM DIAGNÓSTICO POR IMAGEM PARA EMISSÃO DE LAUDOS, E FORNECIMENTO DE PROFISSIONAL CAPACITADO PARA REALIZAÇÃO DO EXAME CLÍNICO DAS MAMAS, COM MÃO DE OBRA QUALIFICADA E INSUMOS NECESSÁRIOS PARA ATENDIMENTO AOS SERVIDORES DESTA CASA LEGISLATIVA E A POPULAÇÃO EM GERAL ATRAVÉS DO PROGRAMA ALEPE MULHER.</td>  
                        </tr>
                    </tbody>
                </Table>
                <Table striped bordered hover>
                    <tbody>
                        <tr>
                            <th>Aviso de Dispensa</th>
                            <th colSpan={2}>
                            AVISO DE DISPENSA nº 001/2024 – COM BASE NO ART. Nº 75, INCISO II da Lei 14.133/2021
                            <br/>
                            <br/>
                            A ASSEMBLEIA LEGISLATIVA DE PERNAMBUCO, em conformidade com Art. 75, inciso II – da Lei Federal n.º 14.133/2021, torna público aos interessados que a administração pública pretende realizar a CONTRATAÇÃO DE EMPRESA ESPECIALIZADA PARA A IMPLEMENTAÇÃO DO PROJETO, CUJO FOCO É A PREVENÇÃO DE AMPUTAÇÕES E CUIDADOS COM O DIABETES, ENVOLVENDO AS ETAPAS DE CADASTRO, MAPEAMENTO E PRESTAÇÃO DE SERVIÇOS DE SAÚDE ESPECÍFICOS PARA INDIVÍDUOS INVESTIGADOS COM SÍNDROME DIABÉTICA, podendo eventuais interessados apresentarem Proposta de Preços no prazo de 3 (três) dias úteis, a contar desta Publicação, oportunidade em que a administração escolherá a mais vantajosa. 
                            <br/>
                            <br/>
                            Limite para Apresentação da Proposta de Preços: 02/02/2024 às 14:00h
                            <br/>
                            <br/>
                            A documentação de habilitação e proposta de Preços deverá ser encaminhada para o E-mail: alepe.licita@gmail.com,   até a data limite. O Edital/Termo de Referência da Dispensa estará disponível no Site Oficial da ALEPE https://transparencia.alepe.pe.gov.br/ ou através do E-mail: alepe.licita@gmail.com.  Outras informações poderão ser obtidas na Sala da CPL, sito a Rua da União, nº 439, 3º andar, Boa Vista, Recife/PE, no horário das 08h:00 às 18h:00 de segunda a quinta e na sexta feira até as 13h:00. Recife, 29 de janeiro de 2024.
                            </th>
                        </tr>
                        <tr>
                            <th><b>Nº da Dispensa</b></th>
                            <th><b>Arquivos</b></th>
                            <th><b>Objeto</b></th>
                        </tr>
                        <tr>
                            <td style={{ width: '13%'}}>{1 + "/" + 2024}</td>
                            <td style={{ width: '23%'}}>
                                <Link to={"https://www.alepe.pe.gov.br/downloads/dispensa/edital-dispensa-01-2024.pdf"} target="_blank">Edital</Link>
                            </td>
                            <td>CONTRATAÇÃO DE EMPRESA ESPECIALIZADA PARA A IMPLEMENTAÇÃO DO PROJETO, CUJO FOCO É A PREVENÇÃO DE AMPUTAÇÕES E CUIDADOS COM O DIABETES, ENVOLVENDO AS ETAPAS DE CADASTRO, MAPEAMENTO E PRESTAÇÃO DE SERVIÇOS DE SAÚDE ESPECÍFICOS PARA INDIVÍDUOS INVESTIGADOS COM SÍNDROME DIABÉTICA</td>  
                        </tr>
                    </tbody>
                </Table> */}
            </div>
        </Col>
        <Col xs="6" className="text-start">
            {page > 0 ? 
                <a href="#" onClick={(e) => {previousPage();}}>Página Anterior</a>
            : null}
        </Col> 
        <Col xs="6" className="text-end">
            {licitacoes.length == 10 ? 
                <a href="#" onClick={(e) => {nextPage();}}>Próxima Página</a>
            : null}
        </Col> 
        {/*<Col xs="12" className="text-center">
            <CleanPagination
                totalPages={totalPages}
                currentPage={currentPage}
                onPageChange={handlePageSelect}
            />
        </Col>*/}
    </Row>
}